// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2lxpg","box":"WorkspacesBox_box__3Tdf2","node":"WorkspacesBox_node__gqpm7"};